import { render, staticRenderFns } from "./ChangeTimeDurationDropdown.vue?vue&type=template&id=539a6c27"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports